// Importing necessary libraries and components
import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "@mui/material";
import "./PolicyWallet.scss";
import InsurerCard from "./InsurerCard/InsurerCard";
import InsurancePolicyDetails from "./InsurancePolicyDetail/InsurancePolicyDetail";
import AddRetailPolicy from "./AddRetailPolicy/AddRetailPolicy";
import HealthRetailPolicy from "./HealthRetailPolicy/HealthRetailPolicy";
import CarRetailPolicy from "./CarRetailPolicy/CarRetailPolicy";
import { useNavigate } from "react-router-dom";
// Main function component
function PolicyWallet() {
  // State for retail policy
  const [retailPolicy, setAddRetailPolicy] = useState(false);
  const [healthRetailPolicy, setHealthRetailPolicy] = useState(false);
  const [carRetailPolicy, setCarRetailPolicy] = useState(false);

  // Insurer data
  const insurer = [
    {
      productlogo: "./images/car_employee_img.svg",
      insurancetype: "Car",
      insurerlogo: "./images/insurerlogo/digit.svg",
      heading1: "HR 01 AB 1234",
      heading2: "126 Days Left",
      eyes: "./images/eyes.svg",
      heading3: "Hyundai Creta",
      spanheading2: "Diesel, 1.6 SX (0) 1582 cc",
      buttontextactive: "Active",
      buttonclassactive1: "button",
      buttonclassactive2: "green",
    },
    {
      productlogo: "./images/term_employee_img.svg",
      insurancetype: "Term",
      insurerlogo:
        "./images/insurerlogo/HDFC-Standard-Life-Insurance-Co-Ltd.svg",
      heading1: " ₹ 1 Crore",
      heading2: "Click 2 Protect Life",
      eyes: "./images/eyes.svg",
      heading3: "50 Years",
      heading4: "20 Years",
      spanheading1: "Sum Assured:",
      spanheading2: "Policy Term",
      spanheading3: "Pay Upto",
      buttontextactive: "Active",
      buttonclassactive1: "button",
      buttonclassactive2: "red",
    },
    {
      productlogo: "./images/car_employee_img.svg",
      insurancetype: "Car",
      insurerlogo: "./images/insurerlogo/digit.svg",
      heading1: "HR 01 AB 1234",
      heading2: "0 Days Left",
      eyes: "./images/eyes.svg",
      heading3: "Hyundai Creta",
      spanheading2: "Diesel, 1.6 SX (0) 1582 cc",
      buttontextrenew: "Renew",
      buttonclass1: "button",
      buttonclass2: "purple",
      buttontextactive: "Active",
      buttonclassactive1: "button",
      buttonclassactive2: "green",
    },
  ];

  const policyCard = [
    {
      productlogo: "./images/health_insurance_img.svg",
      insurerlogo: "./images/insurerlogo/Royal_Sundaram.svg",
      heading1: "Health",
      heading2: "Policy No.",
      heading3: " Coverage for",
      spanheading1: "Insurance",
      spanheading2: "5897985465868",
      spanheading3: "2 Adults & 1 Child",
      classvalue: "green",
      boxcolor: "health",
      colorid: "blue-gradient",
    },
    {
      productlogo: "./images/term_insurance.svg",
      insurerlogo:
        "./images/insurerlogo/HDFC-Standard-Life-Insurance-Co-Ltd.svg",
      heading1: "Term",
      heading2: "Policy No.",
      heading3: "Sum Assured",
      spanheading1: "Insurance",
      spanheading2: "5897985465868",
      spanheading3: "₹ 5 Lakh",
      classvalue: "orange",
      boxcolor: "termins",
      colorid: "orange-gradient",
    },
    {
      productlogo: "./images/super_topup.svg",
      insurerlogo: "./images/insurerlogo/digit.svg",
      heading1: "Super",
      heading2: "Policy No.",
      heading3: "Sum Insured",
      spanheading1: "Top-up",
      spanheading2: "5897985465868",
      spanheading3: "₹ 50 Lakh",
      classvalue: "purple",
      boxcolor: "super",
      colorid: "bluegradient",
    },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === "health") {
      if (value === 0) {
        setCarRetailPolicy(true);
      } else if (value === 1) {
        setHealthRetailPolicy(true);
      }
    }
  };

  return (
    <>
      <AddRetailPolicy
        open_status={retailPolicy}
        attrName={setAddRetailPolicy}
        value_update={updateMasterState}
      />
      <HealthRetailPolicy
        open_status={healthRetailPolicy}
        attrName={setHealthRetailPolicy}
        value_update={updateMasterState}
      />
      <CarRetailPolicy
        open_status={carRetailPolicy}
        attrName={setCarRetailPolicy}
        value_update={updateMasterState}
      />
      <Grid xs className="policyWallet_wrapper">
        <Grid container spacing={3}>
          <Grid xs={12} className="main_heading mb-6">
            <h5>
              Policy <span> Wallet</span>
            </h5>
            <p>
              This is your digital space where you can keep a track of all the
              policies.
            </p>
          </Grid>
        </Grid>
        <div className="corporate_section">
          <Grid container spacing={3}>
            <Grid xs={2} style={{ alignSelf: "center" }}>
              <h6>
                Corporate <br /> Policy
              </h6>
              <p>
                It is provided by <br /> your employer
              </p>
            </Grid>
            {policyCard.map((data, index) => (
              <Grid md={6} lg={4} xl={3}>
                <InsurancePolicyDetails
                  productlogo={data.productlogo}
                  insurerlogo={data.insurerlogo}
                  spanheading1={data.spanheading1}
                  heading1={data.heading1}
                  heading2={data.heading2}
                  heading3={data.heading3}
                  spanheading2={data.spanheading2}
                  spanheading3={data.spanheading3}
                  classvalue={data.classvalue}
                  boxcolor={data.boxcolor}
                  colorid={data.colorid}
                />
              </Grid>
            ))}
          </Grid>
        </div>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <div className="retail_policy_box">
              <Link onClick={() => setAddRetailPolicy(true)}>
                <img
                  src="./images/retail_policy_img.svg"
                  alt="retail image"
                  className="retail_img"
                />
              </Link>
              <div className="retail_text_section">
                <h5>Add Retail Policy</h5>
                <p>Add policy which you have bought from others.</p>
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          {insurer.map((data, index) => (
            <Grid md={6} lg={4} xl={3}>
              <InsurerCard
                productlogo={data.productlogo}
                insurancetype={data.insurancetype}
                insurerlogo={data.insurerlogo}
                spanheading1={data.spanheading1}
                heading1={data.heading1}
                heading2={data.heading2}
                eyes={data.eyes}
                heading3={data.heading3}
                heading4={data.heading4}
                spanheading2={data.spanheading2}
                spanheading3={data.spanheading3}
                buttontextrenew={data.buttontextrenew}
                buttonclass1={data.buttonclass1}
                buttonclass2={data.buttonclass2}
                buttontextactive={data.buttontextactive}
                buttonclassactive1={data.buttonclassactive1}
                buttonclassactive2={data.buttonclassactive2}
                value_update={updateMasterState}
                index={index}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
}

export default PolicyWallet;
